import { render, staticRenderFns } from "./DetalleComision.vue?vue&type=template&id=15fcb7a5&scoped=true&"
import script from "./DetalleComision.vue?vue&type=script&lang=js&"
export * from "./DetalleComision.vue?vue&type=script&lang=js&"
import style0 from "./DetalleComision.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DetalleComision.vue?vue&type=style&index=1&lang=css&"
import style2 from "./DetalleComision.vue?vue&type=style&index=2&id=15fcb7a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fcb7a5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VDivider,VRadio,VRadioGroup})
